/** GameWiki 子系统 appId，用于 postMessage 校验 */
export const GAMEWIKI_APP_ID = 'gamewiki';

/** 父页面挂载路径（不含 /v2 base） */
export const GAMEWIKI_MOUNT_PATH = '/gamewiki';

/** GameWiki 子应用部署 base，与 VITE_BASE_PATH 一致，无尾斜杠 */
export const GAMEWIKI_BASE = '/kb';

/** 子应用默认入口路由（不含 /kb 前缀） */
export const DEFAULT_EMBED_ROUTE = '/platform/workbench';

/** 个人空间在父地址栏中的 spaceId 标识；子路由无 tenantId/fromTenantId 时对应此值 */
export const GAMEWIKI_PERSONAL_SPACE_ID = 'personal';

/**
 * GameWiki 子路由白名单：仅允许工作台及 /platform 下路径写入父 URL。
 * @param path - 子应用 path 段（不含 query）
 * @returns true 表示合法路径；false 表示异常值应丢弃
 */
export const isGameWikiAllowedEmbedPath = (path: string): boolean =>
  path === DEFAULT_EMBED_ROUTE || path.startsWith('/platform/');
